function OIcon({ className }) {
  return (
    <svg
      data-testid="o-icon"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
        stroke="#FFFFFF"
        strokeWidth="5"
      />
    </svg>
  );
}

export default OIcon;
